var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cms-block",style:({
        height: _vm.block.value.space + 'px'
    })})
}
var staticRenderFns = []

export { render, staticRenderFns }